'use strict';

import BaseService from './base.service';

class ChecksService extends BaseService {
    /* @ngInject */
    constructor(Check, SegaUser) {
        super(Check, SegaUser);
    }

    create(data) {
        return this.Model.create(data);
    }
}

export default ChecksService;
